<ng-diagram-base-node-template [node]="node()">
  <div class="rounded-5 eNode"></div>
</ng-diagram-base-node-template>

<ng-diagram-port id="eport-bottom" type="both" side="bottom" />
<ng-diagram-port id="eport-top" type="both" side="top" />
